var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isDark ? 'theme-dark' : 'theme-light',attrs:{"id":"app"}},[(_vm.$route.name !== 'Login')?_c('TheNavbar',{attrs:{"is-dark":_vm.isDark},on:{"toggle-theme":_vm.toggleTheme}}):_vm._e(),_c('router-view'),(_vm.showSiteFooter)?_c('TheFooter',{attrs:{"is-dark":_vm.isDark}}):_vm._e(),(_vm.showFloatingBar)?_c('FloatingBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }